import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-notes-button',
  templateUrl: './notes-button.component.html',
  styleUrls: ['./notes-button.component.scss']
})
export class NotesButtonComponent {
  @Input() text: string = 'Notes';
  @Input() counter: number | null;
  @Input() label: string | null;
}
